import type { ScoreBarRange } from '@ksyos/design-system/dist/components/score-bar';
import { Box, ScoreBar, Text } from '@ksyos/design-system';
import { QuestionnaireName } from '@common/enums';
import { questionnaireProperties } from './questionnaireProperties';

interface IQuestionnaireHeaderScoreProps {
    questionnaireName: QuestionnaireName;
    value: number;
}
export function QuestionnaireHeaderScore(props: Readonly<IQuestionnaireHeaderScoreProps>) {
    const { questionnaireName, value } = props;

    const questionnaire = questionnaireProperties[questionnaireName as keyof typeof questionnaireProperties];

    return (
        <Box
            alignItems="center"
            display="grid"
            gap={6}
            gridTemplateColumns={['1fr', null, '50px 1fr 250px']}
            width="100%"
        >
            <Text
                fontWeight="medium"
                size="sm"
                whiteSpace="nowrap"
            >
                {questionnaireName === QuestionnaireName.osasHsdq ? 'HSDQ' : 'ESS'}
            </Text>

            <ScoreBar
                maxValue={questionnaire.maxValue}
                minValue={questionnaire.minValue}
                range={questionnaire.range}
                rangeStops={questionnaire.rangeStops}
                value={value}
                valueRange={getRangeValue()}
            />

            <Text
                fontWeight="medium"
                size="sm"
                sx={{ width: ['100%', null, 'auto'] }}
                textAlign={['right', null, 'left']}
                whiteSpace="nowrap"
            >
                {questionnaire.getMessage(value)}
            </Text>
        </Box>
    );

    function getRangeValue(): ScoreBarRange {
        const rangeIndex = getRangeIndex(
            value,
            questionnaire.minValue,
            questionnaire.maxValue,
            questionnaire.rangeStops
        );

        return questionnaire.range[rangeIndex];
    }

    function getRangeIndex(scoreValue: number, minValue: number, maxValue: number, rangeStops: number[]): number {
        const valueAsPrecentage = (scoreValue / maxValue) * 100;
        if (scoreValue <= minValue) {
            return 0;
        } else if (scoreValue >= maxValue) {
            return rangeStops.length;
        } else {
            let i = 0;

            while (i < rangeStops.length && valueAsPrecentage > rangeStops[i]) {
                i++;
            }

            return i;
        }
    }
}
